import type { NextRouter } from "next/router";
import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import type { CustomerLoginState } from "@Front/Components/Layouts/Login/hooks/helpers/loginStateHook";
import {
	useLoginChallengesHandlers,
	type LoginChallengesHandlersResult,
} from "@Front/Components/Layouts/Login/hooks/useLoginChallengesHandlers";
import { useLoginPasswordFlowHandlers } from "@Front/Components/Layouts/Login/hooks/useLoginPasswordFlowHandlers";

export function useCustomerLoginHandlers(params: {
	router: NextRouter;
	loginScope: CustomerLoginRouterScope;
	loginState: CustomerLoginState;
	refresh: () => Promise<void>;
}): LoginChallengesHandlersResult & {
	onNewPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
	onPasswordSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: Record<string, string>) => Promise<void>;
	onPasswordForgotClicked: () => void;
	onSendAnotherCode: () => void;
} {
	const challenges = useLoginChallengesHandlers({
		router: params.router,
		loginScope: params.loginScope,
		loginState: params.loginState,
		refresh: params.refresh,
	});
	const passwordFlow = useLoginPasswordFlowHandlers({
		router: params.router,
		loginScope: params.loginScope,
		loginState: params.loginState,
		refresh: params.refresh,
	});
	return { ...challenges, ...passwordFlow };
}
